<template>
  <div :class="['history-btn', disabled ? 'disabled' : '']">
    <secondary-button
      :disabled="disabled"
      type="new-secondary"
      @click="$emit('click')"
    >
      <template #prepend>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
        >
          <path
              d="M6.99972 0.142853C5.24181 0.147867 3.55297 0.827822 2.28201 2.04228V0.828567C2.28201 0.646704 2.20976 0.47229 2.08117 0.343694C1.95257 0.215097 1.77815 0.142853 1.59629 0.142853C1.41443 0.142853 1.24002 0.215097 1.11142 0.343694C0.982823 0.47229 0.910578 0.646704 0.910578 0.828567V3.91428C0.910578 4.09614 0.982823 4.27056 1.11142 4.39915C1.24002 4.52775 1.41443 4.59999 1.59629 4.59999H4.68201C4.86387 4.59999 5.03828 4.52775 5.16688 4.39915C5.29548 4.27056 5.36772 4.09614 5.36772 3.91428C5.36772 3.73242 5.29548 3.558 5.16688 3.42941C5.03828 3.30081 4.86387 3.22857 4.68201 3.22857H3.03629C3.91797 2.30721 5.09309 1.72182 6.35963 1.57303C7.62616 1.42424 8.90497 1.72135 9.97617 2.41328C11.0474 3.10522 11.844 4.14874 12.2292 5.36442C12.6144 6.58011 12.5639 7.89201 12.0866 9.07455C11.6093 10.2571 10.7349 11.2364 9.61377 11.8441C8.49263 12.4518 7.1948 12.6499 5.94342 12.4043C4.69204 12.1588 3.5653 11.4849 2.75693 10.4986C1.94855 9.51234 1.50906 8.27523 1.51401 6.99999C1.51401 6.81813 1.44176 6.64372 1.31317 6.51512C1.18457 6.38652 1.01015 6.31428 0.828292 6.31428C0.64643 6.31428 0.472015 6.38652 0.343419 6.51512C0.214823 6.64372 0.142578 6.81813 0.142578 6.99999C0.142578 8.35621 0.544742 9.68197 1.29821 10.8096C2.05169 11.9373 3.12263 12.8162 4.3756 13.3352C5.62858 13.8542 7.00733 13.99 8.33748 13.7254C9.66764 13.4608 10.8895 12.8077 11.8485 11.8487C12.8074 10.8897 13.4605 9.66791 13.7251 8.33776C13.9897 7.0076 13.8539 5.62886 13.3349 4.37588C12.8159 3.1229 11.937 2.05196 10.8093 1.29849C9.68169 0.545017 8.35593 0.142853 6.99972 0.142853ZM6.99972 4.25714C6.81786 4.25714 6.64344 4.32938 6.51485 4.45798C6.38625 4.58658 6.31401 4.76099 6.31401 4.94285V6.99999C6.31401 7.18186 6.38625 7.35627 6.51485 7.48487C6.64344 7.61346 6.81786 7.68571 6.99972 7.68571H8.37115C8.55301 7.68571 8.72742 7.61346 8.85602 7.48487C8.98462 7.35627 9.05686 7.18186 9.05686 6.99999C9.05686 6.81813 8.98462 6.64372 8.85602 6.51512C8.72742 6.38652 8.55301 6.31428 8.37115 6.31428H7.68543V4.94285C7.68543 4.76099 7.61319 4.58658 7.48459 4.45798C7.356 4.32938 7.18158 4.25714 6.99972 4.25714Z"
              :fill="!themeStatus ? '#744DB2' : '#FFFFFF'"
          />
        </svg>
      </template>
    </secondary-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HistoryButton",
  components: {
    SecondaryButton: () => import(/* webpackChunkName: "public/components/common/uiKit/button/base/bg-secondary" */ '/public/components/common/uiKit/button/base/bg-secondary'),
  },
    props: {
      disabled: {
          type: Boolean,
          default: false
      }
    },
  computed: {
    ...mapState(['themeStatus']),
  }
}
</script>

<style lang="scss">
  .history-btn {
    width: 48px;
    min-width: 48px;

    .new-secondary {
      background-color: var(--new-front-bg-secondary)!important
    }
  }
  .disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.5;
  }
</style>
